import { createBrowserHistory } from 'history'

const _history = createBrowserHistory()

export default () => _history
